// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"5936":"css/admin-app.7065","7323":"css/app.7065"}[chunkId] + ".css";
};